import React from 'react';
import { Avatar as MuiAvatar, getAvatarUtilityClass } from '@mui/material';
import clsx from 'clsx';
import { AvatarProps } from './types';

export function Avatar(props: AvatarProps) {
  const {
    size = 'lg',
    color = 'light',
    className,
    ...rest
  } = props;

  return (
    <MuiAvatar
      className={clsx(
        getAvatarUtilityClass(size),
        getAvatarUtilityClass(color),
        className,
      )}
      {...rest}
    />
  );
}
